// extracted by mini-css-extract-plugin
export var arrowDown = "OddsDisplay-module--arrowDown--8b08a";
export var arrowUp = "OddsDisplay-module--arrowUp--54ddd";
export var flucIn = "OddsDisplay-module--flucIn--0675a";
export var incoming = "OddsDisplay-module--incoming--59539";
export var newOdds = "OddsDisplay-module--newOdds--e4d12";
export var oddsCenter = "OddsDisplay-module--oddsCenter--d42fb";
export var oddsChange = "OddsDisplay-module--oddsChange--78e30";
export var previousOdds = "OddsDisplay-module--previousOdds--2c97b";